module.exports = __webpack_public_path__ + "static/media/Cowbell808.144a4c6d.wav";